jQuery(document).ready(function ($) {

	// click on link of blog anchor menu
	$('.blog-menu-anchor').on('click', function (e) {
		e.preventDefault();

		const targetId = $(this).attr('href').replace('#', '');
		const $target = $('#' + targetId);

		if (!$target.length) return;

		const offset = 90; // header height + offset
		const elementPosition = $target.offset().top;
		const offsetPosition = elementPosition - offset;

		$('html, body').animate(
			{ scrollTop: offsetPosition },
			300
		);
	});

	// ===========================
	// Mobile menu (toggle)
	// ===========================

	// open
	$('#mobile-menu-toggle').on('click', function () {
		const isOpen = $(this).attr('aria-expanded') === 'true';

		$('#mobile-menu').slideToggle(200);
		$(this).toggleClass('open');
		$(this).attr('aria-expanded', !isOpen);
	});

	// close
	$('#mobile-menu a').on('click', function () {
		$('#mobile-menu').slideUp(200);
		$('#mobile-menu-toggle').removeClass('open');
	});

	function updateProgress() {
		var scrollTop = $(window).scrollTop();
		var docHeight = $(document).height() - $(window).height();
		var progress = (scrollTop / docHeight) * 100;

		$('#progressBar').css('width', progress + '%');
	}

	$(window).on('scroll', function(){
		updateProgress();
	});

	// Scroll Top Button

	const btn = $('#scrollTopBtn');

	$(window).on('scroll', function () {

		if ($(this).scrollTop() > 400) {
			btn.removeClass('opacity-0 invisible')
			.addClass('opacity-100 visible');
		} else {
			btn.removeClass('opacity-100 visible')
			.addClass('opacity-0 invisible');
		}

	});

	btn.on('click', function () {

		$('html, body').animate({
			scrollTop: 0
		}, 500);

	});

	// List Show More Button

	$('.city-list').each(function () {

		const $list = $(this);
		const $items = $list.find('.city-item');
		const $btn = $list.parent().find('.show-more-btn');

		if (!$items.length || !$btn.length) return;

		let visibleCount = 25;
		const step = 20;

		function updateVisibility() {

			$items.each(function (index) {

				if (index < visibleCount) {
					$(this).show();
				} else {
					$(this).hide();
				}

			});

			if (visibleCount >= $items.length) {
				$btn.hide();
			}

		}

		updateVisibility();

		$btn.on('click', function () {
			visibleCount += step;
			updateVisibility();
		});

	});

	// =======================
	// FAQ accordeon
	// ===========================
	const $accordion = $('#faq-accordion');
	const $items = $accordion.find('.faq-item');

	$accordion.on('click', '.faq-toggle', function () {

		const $item = $(this).closest('.faq-item');

		if ($item.hasClass('is-active')) {
			closeItem($item);
		} else {
			$items.each(function () {
				closeItem($(this));
			});
			openItem($item);
		}

	});

	function openItem($item) {
		$item.addClass('is-active border-blue-500 shadow-md')
			.removeClass('border-gray-200');

		$item.find('.faq-title')
			.addClass('text-blue-700')
			.removeClass('text-gray-800');

		$item.find('.faq-content')
			.removeClass('max-h-0 opacity-0')
			.addClass('max-h-[600px] opacity-100');

		$item.find('.icon-plus').addClass('hidden');
		$item.find('.icon-minus').removeClass('hidden');
	}

	function closeItem($item) {

		$item.removeClass('is-active border-blue-500 shadow-md')
			.addClass('border-gray-200');

		$item.find('.faq-title')
			.removeClass('text-blue-700')
			.addClass('text-gray-800');

		$item.find('.faq-content')
			.removeClass('max-h-[600px] opacity-100')
			.addClass('max-h-0 opacity-0');

		$item.find('.icon-plus').removeClass('hidden');
		$item.find('.icon-minus').addClass('hidden');
	}

	// Pagination

	$(document).on(
		'click',
		'.lawyer-page-btn',
		function () {

			const page = $(this).data('page');

			const $wrapper = $('#lawyers-wrapper');

			$.ajax({

				url: myAjax.ajaxurl,

				type: 'POST',

				data: {

					action: 'load_lawyers_page',

					page: page,

					spec: $wrapper.data('spec'),

					city: $wrapper.data('city')

				},

				success: function (res) {

					if (!res.success)
						return;

					$('#lawyers-body')
						.html(res.data.rows);

					$('#lawyers-pagination')
						.replaceWith(res.data.pagination);

				}

			});

		}
	);

	$(document).on(
		'click',
		'.online-lawyer-page-btn',
		function () {

			const page = $(this).data('page');

			$.ajax({

				url: myAjax.ajaxurl,

				type: 'POST',

				data: {

					action: 'load_online_lawyers_page',

					page: page

				},

				success: function (res) {

					if (!res.success)
						return;

					$('#online-lawyers-body')
						.html(res.data.rows);

					$('#online-lawyers-pagination')
						.replaceWith(res.data.pagination);

				}

			});

		}
	);

	$(document).on(
		'click',
		'.lawyer-spec-page-btn',
		function () {

			const page = $(this).data('page');

			const specId = $('#lawyers-spec-wrapper')
				.data('spec-id');

			$.ajax({

				url: myAjax.ajaxurl,

				type: 'POST',

				data: {

					action: 'load_lawyers_by_spec_page',

					page: page,

					spec_id: specId

				},

				success: function (res) {

					if (!res.success)
						return;

					$('#lawyers-spec-body')
						.html(res.data.rows);

					$('#lawyers-spec-pagination')
						.replaceWith(res.data.pagination);

				}

			});

		}
	);

	$(document).on(
		'click',
		'.city-lawyer-page-btn',
		function () {

			const page = $(this).data('page');

			const cityId =
				$('#city-lawyers-wrapper')
					.data('city-id');

			$.ajax({

				url: myAjax.ajaxurl,

				type: 'POST',

				data: {

					action:
						'load_city_lawyers_page',

					page: page,

					city_id: cityId

				},

				success: function (res) {

					if (!res.success)
						return;

					$('#lawyers-spec-body')
						.html(res.data.rows);

					$('#city-lawyers-pagination')
						.replaceWith(
							res.data.pagination
						);

				}

			});

		}
	);

	// Show More Btn Cities List

	$(document).on(
		'click',
		'#show-more-cities',
		function () {

			const hiddenItems =
				document.querySelectorAll('.city-hidden');

			let count = 0;

			hiddenItems.forEach(function (item) {

				if (count >= 50) {
					return;
				}

				item.classList.remove(
					'hidden',
					'city-hidden'
				);

				count++;

			});

			if (
				document.querySelectorAll('.city-hidden').length === 0
			) {
				$(this).remove();
			}

		}
	);

	// =======================
	// City Search (Admin)
	// =======================

	if ($('#city-search').length) {

		let timer = null;

		const $searchInput = $('#city-search');
		const $resultsBox  = $('#city-results');
		const $selectedBox = $('#city-selected');
		const $hiddenInput = $('#selected-city');

		const nonce  = citySearch.nonce;
		const ajaxurl = citySearch.ajaxurl;

		$searchInput.on('keyup', function () {

			clearTimeout(timer);

			const query = $(this).val().trim();

			if (query.length < 2) {
				$resultsBox.hide();
				return;
			}

			timer = setTimeout(function () {

				const formData = new FormData();
				formData.append('action', 'search_cities');
				formData.append('q', query);
				formData.append('nonce', nonce);

				fetch(ajaxurl, {
					method: 'POST',
					credentials: 'same-origin',
					body: formData
				})
				.then(r => r.text())
				.then(html => {

					$resultsBox.html(html).show();

				});

			}, 300);

		});

		$resultsBox.on('click', '.city-item', function () {

			const id = $(this).data('id');
			const label = $(this).text();

			$hiddenInput.val(id);

			$selectedBox
				.html('Selected: <strong>' + label + '</strong>')
				.show();

			$resultsBox.hide();
			$searchInput.val(label);

		});

		$(document).on('click', function (e) {

			if (!$(e.target).closest('.city-search-wrap').length) {
				$resultsBox.hide();
			}

		});

	}

	function initMobileReminder() {

		const $reminder = $('#appReminder');
		if (!$reminder.length) return;

		const $iosLink = $('#app-link-ios');
		const $androidLink = $('#app-link-android');
		const $closeBtn = $reminder.find('button');

		const userAgent = navigator.userAgent || navigator.vendor || window.opera;

		const isIOS = /iPad|iPhone|iPod/.test(userAgent);
		const isAndroid = /android/i.test(userAgent);

		if (isIOS) {

			if ($iosLink.length) {
				$iosLink.removeClass('hidden');
			} else {
				$reminder.hide();
				return;
			}

		} else if (isAndroid) {

			if ($androidLink.length) {
				$androidLink.removeClass('hidden');
			} else {
				$reminder.hide();
				return;
			}

		} else {

			$reminder.hide();
			return;

		}

		$closeBtn.on('click', function () {
			$reminder.hide();
		});

	}

	initMobileReminder();

	// =====================
	// Form
	// =====================

	function initCrmForms() {

		const isValidName = v =>
			/^[a-zA-Zа-яА-ЯіІїЇєЄґҐ\s'-]{2,}$/.test(v.trim());

		const isValidPhone = v => {
			const clean = v.replace(/\D/g, '');
			return /^1\d{10}$/.test(clean);
		};

		const isValidText = v => v.trim().length >= 2;


		// =====================
		// Phone format
		// =====================

		function formatPhone(value) {

			let digits = value.replace(/\D/g, '');

			if (digits.startsWith('1')) {
				digits = digits.slice(1);
			}

			digits = digits.substring(0, 10);

			let result = '+1 ';

			if (digits.length > 0) {
				result += '(' + digits.substring(0, 3);
			}

			if (digits.length >= 3) {
				result += ') ' + digits.substring(3, 6);
			}

			if (digits.length >= 6) {
				result += '-' + digits.substring(6, 10);
			}

			return result;
		}


		// =====================
		// Phone mask
		// =====================

		$(document).on('focus', '.crm-form input[name="phone"], .lawyer-form input[name="phone"]', function () {
			if (!$(this).val()) {
				$(this).val('+1 ');
			}
		});

		$(document).on('input', '.crm-form input[name="phone"], .lawyer-form input[name="phone"]', function () {
			$(this).val(formatPhone($(this).val()));
		});

		$(document).on('keydown', '.crm-form input[name="phone"], .lawyer-form input[name="phone"]', function (e) {

			const input = this;

			if (input.selectionStart < 3 && e.key !== 'Backspace' && e.key !== 'Delete') {
				e.preventDefault();
				input.setSelectionRange(3, 3);
				return;
			}

			const isDelete = e.key === 'Backspace' || e.key === 'Delete';

			if (!isDelete) return;

			const digits = input.value.replace(/\D/g, '');

			if (
				input.selectionStart === 0 &&
				input.selectionEnd === input.value.length
			) {
				e.preventDefault();
				input.value = '+1 ';
				return;
			}

			if (input.selectionStart <= 3) {
				e.preventDefault();
				return;
			}

			e.preventDefault();

			let clean = digits.startsWith('1')
				? digits.slice(1)
				: digits;

			clean = clean.slice(0, -1);

			input.value = formatPhone('+1' + clean);

		});


		// =====================
		// Remove error on input
		// =====================

		$(document).on('input', '.crm-form input, .crm-form textarea, .lawyer-form input, .lawyer-form textarea', function () {
			$(this).removeClass('crm-error');
		});


		// =====================
		// Submit
		// =====================

		$(document).on('submit', '.crm-form', function (e) {

			e.preventDefault();

			const $form = $(this);

			const $name = $form.find('[name="crm_name"]');
			const $phone = $form.find('[name="phone"]');
			const $text = $form.find('[name="description"]');

			let valid = true;

			$form.find('input, textarea').removeClass('crm-error');


			if (!isValidName($name.val())) {
				$name.addClass('crm-error');
				valid = false;
			}

			if (!isValidPhone($phone.val())) {
				$phone.addClass('crm-error');
				valid = false;
			}

			if (!isValidText($text.val())) {
				$text.addClass('crm-error');
				valid = false;
			}

			$(document).on(
				'input',
				'.crm-form input, .crm-form textarea',
				function () {
					$(this).removeClass('crm-error');
				}
			);

			if (!valid) return;


			const cleanPhone = $phone.val().replace(/\D/g, '');
			const pageUrl = window.location.href;


			const formData = {

				action: 'send_to_crm',

				crm_name: $name.val(),

				phone: cleanPhone,

				description:
					$text.val() +
					"\n\nPage: " +
					pageUrl,

				crm_city: $form.find('[name="crm_city"]').val(),

				crm_specialization:
					$form.find('[name="crm_specialization"]').val(),

				crm_nonce: $form.find('[name="crm_nonce"]').val()

			};


			const $btn = $form.find('button[type="submit"]');

			$btn.prop('disabled', true);


			$.ajax({

				url: myAjax.ajaxurl,

				type: 'POST',

				data: formData,

				success: function (response) {

					if (response.success) {

						$form[0].reset();

						openPopup('#form-popup-success');

					} else {

						openPopup('#form-popup-reject');

					}

				},

				error: function () {

					openPopup('#form-popup-reject');

				},

				complete: function () {

					$btn.prop('disabled', false);

				}

			});

		});

	}

	// =====================
	// Popup helper
	// =====================

	function openPopup(selector) {

		const popup = document.querySelector(selector);

		if (!popup) return;

		document.body.classList.add('lock');

		popup.classList.add('open');

	}

	initCrmForms();

	// =====================
	// Lawyers popup system
	// =====================

	function setLawyerId(popup, lawyerId) {
		if (!popup || !lawyerId) return;
		
		const form = popup.querySelector('form');
		if (form) form.reset();

		popup.querySelectorAll('input[name="lawyer_id"]').forEach(input => {
			input.value = lawyerId;
		});
	}


	$(document).on('click', '.open-popup', function (e) {

		e.preventDefault();

		const popupSelector = $(this).data('popup');
		const lawyerId = $(this).data('lawyer-id');

		const popup = document.querySelector(popupSelector);

		if (!popup) return;

		setLawyerId(popup, lawyerId);

		openPopup(popupSelector);

	});

	$(document).on('click', '.popup-body', function (e) {
		if (!$(e.target).closest('.popup-content').length) {
			closePopup($(this).closest('.popup'));
		}

	});

	$(document).on('click', '.close-group', function (e) {
		e.preventDefault();

		closePopup($(this).closest('.popup'));
	});


	$(document).on('keydown', function (e) {
		if (e.key === 'Escape') {
			closePopup($('.popup.open'));
		}
	});

	function closePopup($popup) {

		if (!$popup || !$popup.length) return;

		$popup.removeClass('open');

		if (!$('.popup.open').length) {
			$('body').removeClass('lock');
			$('body').css('overflow', '');
		}

	}

	// =====================
	// Lawyer forms (claim/remove)
	// =====================

	$(document).on('submit', '.lawyer-form', function (e) {

		e.preventDefault();

		const $form = $(this);

		const $name = $form.find('[name="crm_name"]');
		const $phone = $form.find('[name="phone"]');
		const $text = $form.find('[name="description"]');

		let valid = true;

		$form.find('input, textarea').removeClass('crm-error');

		const isValidName = v =>
			/^[a-zA-Zа-яА-ЯіІїЇєЄґҐ\s'-]{2,}$/.test(v.trim());

		const isValidPhone = v => {
			const clean = v.replace(/\D/g, '');
			return /^1\d{10}$/.test(clean);
		};

		const isValidText = v => v.trim().length >= 2;

		if (!isValidName($name.val())) {
			$name.addClass('crm-error');
			valid = false;
		}

		if (!isValidPhone($phone.val())) {
			$phone.addClass('crm-error');
			valid = false;
		}

		if (!isValidText($text.val())) {
			$text.addClass('crm-error');
			valid = false;
		}

		if (!valid) return;

		const formData = {
			action: 'send_law_request',
			lawyer_id: $form.find('[name="lawyer_id"]').val(),
			type: $form.find('[name="type"]').val(),
			crm_name: $form.find('[name="crm_name"]').val(),
			phone: $form.find('[name="phone"]').val(),
			description: $form.find('[name="description"]').val(),
			crm_nonce: $form.find('[name="crm_nonce"]').val(),
		};

		const $btn = $form.find('button[type="submit"]');
		$btn.prop('disabled', true);

		$.post(myAjax.ajaxurl, formData, function (res) {
			const $popup = $form.closest('.popup');

			if (res.success) {

				closePopup($popup);

				$form[0].reset();

				openPopup('#form-popup-success');

			} else {

				closePopup($popup);

				if (res.data && res.data.message === 'Request already exists') {
					openPopup('#form-popup-exists');
				} else {
					openPopup('#form-popup-reject');
				}
			}

			}).always(function () {
				$btn.prop('disabled', false);
			});
		});
});
